import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Popup, CircleMarker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./geoui.css"
// Importa el JSON directamente
import locationsData from "./geolocalizacion_clean.json";


// Componente para mover el centro del mapa
const MapCenterUpdater = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    map.setView(center, map.getZoom());
  }, [center, map]);
  return null;
};

const Geo = () => {
  const [locations, setLocations] = useState(locationsData); // Todos los datos
  const [filteredLocations, setFilteredLocations] = useState([]);
  const [selectedState, setSelectedState] = useState("Ciudad de México"); // Estado seleccionado
  const [mapCenter, setMapCenter] = useState([19.432608, -99.133209]); // Coordenadas iniciales (CDMX)

  // Obtener lista única de estados
  const estados = [...new Set(locationsData.map((location) => location.estado))];

  // Filtrar los puntos según el estado seleccionado
  useEffect(() => {
    const filtered = locations.filter(
      (location) => location.estado === selectedState
    );
    setFilteredLocations(filtered);

    // Si hay puntos en el estado seleccionado, actualiza el centro del mapa
    if (filtered.length > 0) {
      const { latitud, longitud } = filtered[0];
      setMapCenter([parseFloat(latitud), parseFloat(longitud)]);
    }
  }, [selectedState, locations]);

  return (
    <div className="geo-container">
      <h1>Geolocalización</h1>

      {/* Select para filtrar por estado */}
      <div style={{ marginBottom: "10px" }}>
        <label htmlFor="estado-select" style={{ marginRight: "10px" }}>
          Filtrar por estado:
        </label>
        <select
          id="estado-select"
          value={selectedState}
          onChange={(e) => setSelectedState(e.target.value)}
        >
          {estados.map((estado, index) => (
            <option key={index} value={estado}>
              {estado}
            </option>
          ))}
        </select>
      </div>

      {/* Mapa con puntos filtrados */}
      <MapContainer
        center={mapCenter} // Centro inicial del mapa
        zoom={5}
        style={{ height: "500px", width: "100%", zIndex: 0 }} // Estilo con z-index
      >
        {/* Componente para actualizar el centro del mapa */}
        <MapCenterUpdater center={mapCenter} />

        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />

        {/* Marcadores dinámicos con colores según el tipo */}
        {filteredLocations.map((location, index) => (
          <CircleMarker
            key={index}
            center={[location.latitud, location.longitud]}
            radius={10} // Tamaño del círculo
            fillColor={
              location.tipo === 'seveneleven' ? "green" :
              location.tipo === 'Upper' ? "red" :
              location.tipo === 'Tiendas3b' ? "blue" :
              location.tipo === 'Gomart' ? "yellow" :
              "gray" // Color por defecto en caso de un tipo desconocido
          }
          
            color={location.tipo === "mi_tienda" ? "blue" : "red"}
            fillOpacity={0.7}
            stroke={false}
          >
            <Popup>
              <b>Tienda:</b> {location.tienda} <br />
              <b>Ciudad:</b> {location.ciudad} <br />
              <b>Estado:</b> {location.estado} <br />
              <b>Codigo postal:</b> {location.codigo_postal} <br />
              <b>Tipo:</b> {location.tipo}
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
};

export default Geo;
